import data from "../../../../../packages/react/src/deprecated/UnderlineNav/UnderlineNav.docs.json";
import * as React from 'react';
export default {
  data,
  React
};